const updateQueryStringParameter = (key, value, notPushHistory) => {
    let uri = window.location.href;
    let resUrl;
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        resUrl = uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        resUrl = uri + separator + key + "=" + value;
    }
    console.log('resUrl', resUrl)
    if('pushState' in history) {
        if(notPushHistory !== true) {
            history.pushState({resUrl, selected}, "", resUrl)
        }
    } else {
        window.location.href = resUrl;
    }
}

const updateBaseUrl = (newUrl, notPushHistory, replace) => {
    replace = replace || false
    if('pushState' in history && !replace) {
        if(notPushHistory !== true) {
            history.pushState({}, "", newUrl)
        }
    } else {
        window.location.href = newUrl;
    }
};


export { updateQueryStringParameter, updateBaseUrl }

document.querySelectorAll('a[data-back-url]').forEach(el => el.addEventListener('click', (e) => {
    if(document.referrer !== '') {
        e.preventDefault();
        window.history.back();
    }
}))
